<template>
  <div class="p-12 space-y-8">
    <div class="flex -mx-4">
      <div class="w-64 px-4 space-y-8">
        <BaseCard>
          <FileUpload @file-upload="updateCover">
            <template #button="{ fileUploadButtonClick }">
              <img
                v-if="account.logo"
                @click="fileUploadButtonClick"
                :src="account.logo"
                class="block rounded w-full cursor-pointer"
              />
              <div
                v-else
                @click="fileUploadButtonClick"
                class="aspect-ratio-square w-full rounded bg-gray-900 cursor-pointer"
              />
            </template>
          </FileUpload>
        </BaseCard>
        <nav class="space-y-1">
          <RouterLink v-for="item in navigation" :key="item.name" :to="item.route" custom>
            <template #default="{ href, navigate, isActive }">
              <a
                :href="href"
                class="flex items-center px-3 py-2 text-sm font-medium rounded-md"
                :class="[
                  isActive
                    ? 'bg-gray-200 text-gray-900 hover:text-gray-900'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                ]"
                @click="navigate"
              >
                <span class="truncate">
                  {{ item.name }}
                </span>
              </a>
            </template>
          </RouterLink>
        </nav>
      </div>
      <div class="flex-1 px-4 space-y-8">
        <Transition name="slide-right" mode="out-in">
          <RouterView />
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import { accountComputed, accountMethods } from '@/store/helper';
import FileUpload from '@/components/Ui/FileUpload.vue';

const navigation = [
  {
    name: 'General',
    route: { name: 'accounts.accountId.settings.general' },
  },
  {
    name: 'Membership product',
    route: { name: 'accounts.accountId.settings.membershipProduct' },
    roles: ['Admin', 'Super Admin'],
  },
  {
    name: 'Tags',
    route: { name: 'accounts.accountId.settings.tags' },
    permissions: ['read tags'],
  },
  {
    name: 'Web Presence',
    route: { name: 'accounts.accountId.settings.webPresences' },
    roles: ['Admin', 'Super Admin'],
  },
  {
    name: 'Social Connections',
    route: { name: 'accounts.accountId.settings.socialConnections' },
    roles: ['Admin', 'Super Admin'],
  },
  {
    name: 'Customer Anatomy',
    route: { name: 'accounts.accountId.settings.customerAnatomy' },
    roles: ['Admin', 'Super Admin'],
  },
  {
    name: 'Attachments',
    route: { name: 'accounts.accountId.settings.attachments' },
    roles: ['Admin', 'Super Admin'],
  },
  {
    name: 'Members',
    route: { name: 'accounts.accountId.settings.members' },
    permissions: ['read memberships'],
  },
  {
    name: 'Integrations',
    route: { name: 'accounts.accountId.settings.integrations' },
    permissions: ['read third party services'],
  },
  {
    name: 'Linked Contacts',
    route: { name: 'accounts.accountId.settings.linkedContacts' },
    roles: ['Admin', 'Super Admin'],
  },
];

export default {
  components: {
    FileUpload,
  },
  props: {
    accountId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...accountComputed,
    navigation() {
      return navigation.filter((item) => {
        if ('roles' in item) {
          return this.$hasRole(item.roles);
        }

        if ('permissions' in item) {
          return this.$membershipHasPermissionTo(item.permissions);
        }

        return true;
      });
    },
  },
  // beforeRouteEnter: middleware('account-permission:edit accounts'),
  methods: {
    ...accountMethods,
    updateCover({ config, data, success, error }) {
      const { accountId } = this;
      this.updateAccountCover({ config, accountId, formData: data })
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    },
  },
};
</script>
